import { render, staticRenderFns } from "./skuEdit.vue?vue&type=template&id=56147d6f&scoped=true&"
import script from "./skuEdit.vue?vue&type=script&lang=js&"
export * from "./skuEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56147d6f",
  null
  
)

export default component.exports